export default __webpack_public_path__ + "static/media/hero.c5b35cbd.jpg";